import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import QRCodeImg from "../../../assets/images/create-consortium/QRCode.svg";
import ConsortiumIcon from "../../../assets/images/create-consortium/consortium-icon.svg";
import ConsortiumQrModal from "./ConsortiumQrModal";
import { getNetworkByUserId } from "../../../api/admin";
import { Spinner } from "react-bootstrap";
import { AdminContext } from "../../../context/AdminContext";
import { toast } from "react-toastify";
import { toastWarning } from "../../Common/ToastAlert";
import customStyles from "../../../assets/sass/Common/selectStyles";

const AllConsortiumList = () => {
  const navigate = useNavigate();
  const [network, setNetwork] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { userId } = useContext(AdminContext);

  // Ensure loading state resets after 1 second if needed
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  // Map the network data including the active property
  const options =
    network?.map((networkItem) => ({
      value: networkItem.name,
      label: networkItem.name,
      id: networkItem.id,
      regionId: networkItem.regionId,
      active: networkItem.active, // add the active property here
    })) || [];

  const fetchAllNetworkData = async () => {
    try {
      setLoading(true);
      const getNetwork = await getNetworkByUserId({ userId });
      const res = getNetwork.data.result;
      setNetwork(res);
      // Set the selected option with the active property
      setSelectedOption(
        res[0]
          ? {
              value: res[0].name,
              label: res[0].name,
              id: res[0].id,
              regionId: res[0].regionId,
              active: res[0].active,
            }
          : null
      );
      setLoading(false);
    } catch (error) {
      toast.warning(error.response.data.message, toastWarning());
      toast.warning(
        "Hmm. Something doesn't seem right. Try refreshing or logging in again.",
        toastWarning()
      );
    }
  };

  useEffect(() => {
    fetchAllNetworkData();
  }, [userId]);

  const navigateToNetwork = (networkId, networkName) => {
    localStorage.setItem("networkId", networkId);
    localStorage.setItem("networkName", networkName);
    navigate("/dashboard", {
      state: { networkId: networkId, networkName: networkName },
    });
  };

  const handleNavigation = (networkId, networkName) => {
    // Only navigate if the network is active
    if (selectedOption?.active) {
      navigateToNetwork(networkId, networkName);
    }
  };

  return (
    <React.Fragment>
      {openModal && (
        <ConsortiumQrModal
          show={openModal}
          onHide={() => setOpenModal(false)}
          data={selectedOption}
        />
      )}
      <div className="consortium-list-page">
        <div className="sub-header">
          <div className="title">Consortiums</div>
          <div className="action-items">
            <div className="d-flex gap-2">
              <button
                className="dsm-btn-secondary action-icon consortium-qr-wiz"
                onClick={() => setOpenModal(true)}
              >
                <img src={QRCodeImg} alt="QR Code" />
              </button>
              <div className="select-item select-consortium-wiz">
                <Select
                  styles={customStyles}
                  closeMenuOnSelect={true}
                  onChange={(option) => setSelectedOption(option)}
                  options={options}
                  defaultValue={selectedOption}
                  placeholder={
                    selectedOption ? selectedOption.label : "Select Network"
                  }
                />
              </div>
            </div>
            <button
              className="dsm-btn-primary create-consortium-step"
              onClick={() => navigate("/home/create-consortium")}
            >
              Create New Consortium
            </button>
          </div>
        </div>
        <div className="body-content">
          {loading ? (
            <div className="loader">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <>
              {selectedOption && (
                <div
                  className={`consortium-card consortium-card-wiz ${
                    !selectedOption.active ? "disabled" : ""
                  }`}
                  key={selectedOption.id}
                  // Disable click when inactive using conditional onClick and pointer events
                  onClick={() =>
                    selectedOption.active &&
                    handleNavigation(selectedOption.id, selectedOption.label)
                  }
                  style={{
                    pointerEvents: selectedOption.active ? "auto" : "none",
                    opacity: selectedOption.active ? 1 : 0.6,
                  }}
                >
                  <div className="card-header">
                    {loading ? (
                      <Skeleton height={28} width={60} />
                    ) : (
                      <span
                        className={
                          selectedOption.active
                            ? "success-badge"
                            : "disabled-badge"
                        }
                      >
                        {selectedOption.active ? "Ready" : "Inactive"}
                      </span>
                    )}
                  </div>
                  <div className="card-body">
                    {loading ? (
                      <Skeleton height={55} width={52} />
                    ) : (
                      <img src={ConsortiumIcon} alt="Consortium Icon" />
                    )}
                    {loading ? (
                      <Skeleton height={27} width={144} />
                    ) : (
                      <p>{selectedOption.label}</p>
                    )}
                  </div>
                  <div className="card-footer">
                    {loading ? (
                      <Skeleton height={21} width={200} />
                    ) : (
                      <>
                        Region:{" "}
                        <span>
                          {selectedOption.regionId
                            ? selectedOption.regionId
                            : "-"}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AllConsortiumList;
